import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Button, Text } from "@zillow/constellation-10";
import { useFormState } from "react-hook-form";
const SimonFields = ({
  buttonText = "Subscribe",
  children,
  legalText = ""
}) => {
  const formStateProxy = useFormState();
  const formState = {
    isSubmitSuccessful: formStateProxy.isSubmitSuccessful,
    isSubmitting: formStateProxy.isSubmitting
  };
  return !formState.isSubmitSuccessful ? /* @__PURE__ */ jsxs(Fragment, { children: [
    children,
    /* @__PURE__ */ jsx(Button, { type: "submit", tone: "brand", emphasis: "filled", disabled: formState.isSubmitting, loading: formState.isSubmitting, children: buttonText }),
    /* @__PURE__ */ jsx(Text, { css: {
      marginTop: "loose"
    }, asChild: true, textStyle: "fineprint-sm", children: /* @__PURE__ */ jsx("p", { children: legalText }) })
  ] }) : null;
};
export {
  SimonFields as default
};
